import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.67",
      d: "M1.667 7.917a4.583 4.583 0 0 1 7.992-3.064.467.467 0 0 0 .682 0 4.575 4.575 0 0 1 7.992 3.064c0 1.908-1.25 3.333-2.5 4.583l-4.576 4.427a1.668 1.668 0 0 1-2.5.016L4.167 12.5c-1.25-1.25-2.5-2.667-2.5-4.583"
    }, null, -1)
  ]))]))
}
export default { render: render }